import { render, staticRenderFns } from "./在线商城详情.vue?vue&type=template&id=5871efb4&scoped=true"
import script from "./在线商城详情.vue?vue&type=script&lang=js"
export * from "./在线商城详情.vue?vue&type=script&lang=js"
import style0 from "./在线商城详情.vue?vue&type=style&index=0&id=5871efb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871efb4",
  null
  
)

export default component.exports